import { matchPath } from "react-router-dom";
import { PanelListContent } from "./content/panelList/panelListContent";
import { DockingPanel } from "./dockingPanel";
import repo from "../../../Repository";

export class PanelListDockingPanel {
    private readonly panel: DockingPanel;
    private readonly modelId: string | null;
    private _visible: boolean;
    private downloadButton;
    private isLoading = false;

    constructor(container: HTMLElement, onVisibilityChanged: (visibility: boolean) => void) {
        this._visible = false;
        this.modelId = matchPath({ path: "/:id", end: false }, window.location.pathname)?.params?.id ?? null;

        const component = <PanelListContent />;

        this.downloadPanelList = this.downloadPanelList.bind(this);

        const panelWidth = 400;
        const panelHeight = 500;
        const containerRect = container.getBoundingClientRect();

        this.panel = new DockingPanel(container, "dextall-panel-list-docking-panel", "Panel List", component, {
            style: {
                resize: "both",
            },
            dimensionsControl: {
                preventOverlapsWithViewerToolbar: true,
                widthDimensionControl: { value: 0.5 * containerRect.width, minValue: panelWidth },
                heightDimensionControl: { value: containerRect.height, minValue: panelHeight },
                topOffset: 4,
                rightOffset: 4,
            },
        });

        if (this.modelId) {
            this.downloadButton = this.panel.addTitleButton({
                title: "Download Panel List",
                iconClass: "docking-panel-title-download-button",
                onClick: this.downloadPanelList,
            });
        }
        this.panel.addToggleFullSizeButton();
        this.panel.addVisibilityListener((x: boolean) => {
            this._visible = x;
            onVisibilityChanged(x);
        });
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }

    private async downloadPanelList() {
        if (this.modelId && !this.isLoading) {
            try {
                this.isLoading = true;
                this.downloadButton?.setIconClass("docking-panel-title-loading-button");
                this.downloadButton?.setTitle("Downloading...");

                const contentResponse = await repo.downloadPanelList(this.modelId);

                if (contentResponse) {
                    const blob = new Blob([contentResponse.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");

                    a.href = url;
                    a.download = "Panel list.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
            } catch (error) {
                console.error("Error during file download:", error);
            } finally {
                this.downloadButton?.setIconClass("docking-panel-title-download-button");
                this.downloadButton?.setTitle("Download Panel List");
                this.isLoading = false;
            }
        }
    }
}
